export interface HelpChatMarkdownPart {
  text: string;
  bold?: boolean;
  italic?: boolean;
  code?: boolean;
  linkUrl?: string;
  headingLevel?: 2 | 3 | 4;
  horizontalRule?: boolean;
  listItem?: boolean;
}

export function parseHelpChatMarkdown(text: string): HelpChatMarkdownPart[] {
  if (!text) return [];
  const parts: HelpChatMarkdownPart[] = [];
  let cursor = 0;
  const pattern = /^(#{2,4})[ \t]+(.+?)[ \t]*$|^[ \t]*([-*_])[ \t]*\3[ \t]*\3[ \t]*$|^[ \t]*[-*+][ \t]+(.+?)[ \t]*$|\*\*(.+?)\*\*|(?<!\*)\*([^*\n]+)\*(?!\*)|`([^`\n]+)`|\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/gm;
  let match: RegExpExecArray | null;
  while ((match = pattern.exec(text))) {
    if (match.index > cursor) parts.push({ text: text.slice(cursor, match.index) });
    if (match[1] !== undefined) parts.push({ text: match[2], headingLevel: Math.min(match[1].length, 4) as 2 | 3 | 4 });
    else if (match[3] !== undefined) parts.push({ text: '', horizontalRule: true });
    else if (match[4] !== undefined) parts.push({ text: match[4], listItem: true });
    else if (match[5] !== undefined) parts.push({ text: match[5], bold: true });
    else if (match[6] !== undefined) parts.push({ text: match[6], italic: true });
    else if (match[7] !== undefined) parts.push({ text: match[7], code: true });
    else parts.push({ text: match[8], linkUrl: match[9] });
    cursor = match.index + match[0].length;
  }
  if (cursor < text.length) parts.push({ text: text.slice(cursor) });
  return parts;
}
